import { Row, Col, Table, Form } from "react-bootstrap";
import { useState, useImperativeHandle, forwardRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AddNewDetail } from "../../Services/wpq_details-service";
import { isAllowDashedSpecialCharacters, isAlphanumericAllSpecialCharacters, numberMax10Digits } from "../../functions/validations";
import { checkboxComponent } from "./WPQObjects/WPQ_entity";
import { Action, Status, MessageTypes } from "../utility/common/constants/CommonConstants"
import {
  Backing,
  Arc_Transfer,
  Consumable_Insert,
  Current_Polarity,
  Backing_Gas,
  Direct_Visual,
  Single_Pass,
  Filler_Wire_With_Without,
  WPQ_FM_Automatic_jointTracking,
  FM_Product_Form_GTAW
} from "../utility/common/TransactionComponents/TransactionEntity";
import { Weld_Progression } from "../WPSTransaction/WPSObjects/WPSGroove_entity";
import { WPQProcessCheckBox, WPQProcessInput1, WPQProcessInput1Row3, WPQProcessInputAndCheckbox, WPQProcessSelect, WPQProcessSelectData } from "./WPQObjects/WPQ_OverlayGroove_InputFields";
import { getActiveSfa } from "../../Services/sfa-service";
import { getActiveFno } from "../../Services/fno-services";
import { emptyErrorWPQDetail } from "./WPQObjects/WPQCommonUtils";
import { DotLoader } from "react-spinners";
import PropTypes from "prop-types";

const WPQGetDetailProcess = forwardRef(
  (
    {
      headerObj,
      Index,
      detailObj,
      setdetailObj,
      wpq_process,
      error,
      setError,
      isDisabled,
      isReadonly,
      IsEdited,
      setIsEdited
    },
    ref
  ) => {
    WPQGetDetailProcess.propTypes = {
      headerObj: PropTypes.array,
      Index: PropTypes.number,
      setdetailObj: PropTypes.func,
      wpq_process: PropTypes.array,
      detailObj: PropTypes.array,
      isDisabled: PropTypes.bool,
      isReadonly: PropTypes.bool,
      error: PropTypes.array,
      setError: PropTypes.func
    };

    console.log("WPQProcess", wpq_process, detailObj)
    const [SfaActive, setSfaActive] = useState([]);
    const [FnoActive, setFnoActive] = useState([]);
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const customstyles = {
      control: (provided) => ({
        ...provided,
        width: "120px",
        margin: "0 auto",
      }),
      menu: (provided) => ({
        ...provided,
        width: "120px",
        left: "50%",
        transform: "translateX(-50%)",
      }),
    };

    const customstyles2 = {
      control: (provided) => ({
        ...provided,
        width: "120px",
        margin: "0 auto",
      }),
      menu: (provided) => ({
        ...provided,
        width: "120px",
        left: "50%",
        transform: "translateX(-50%)",
      }),
    };

    const WPStype = location.state?.WPStype;
    const action = location.state?.action;

    let isgroove = WPStype === "Groove";

    const fetchSfa = async () => {
      const result = await getActiveSfa();
      setSfaActive(result);
    };

    const fetchFno = async () => {
      const result = await getActiveFno();
      setFnoActive(result);
    };

    useEffect(() => {
      fetchSfa();
      fetchFno();
    }, []);

    useImperativeHandle(ref, () => ({
      funcOnNextTemp: async () => {
        return handleSubmitTemp();
      },
    }));

    const handleSubmitTemp = async () => {
      let result = false;
      if (IsEdited) {
        let val = await validateTemp();
        if (val.isError === false) {
          if (val.temperror === false) {
            setIsEdited(false);
            console.log("console.log", IsEdited)
            setLoading(true);
            result = await handleAdd(headerObj?.WPSH_Status);
            setLoading(false);
            if (result) {
              return MessageTypes.Temp;
            }
          }
          return MessageTypes.SpecialCharacters;
        }
        return MessageTypes.Required;
      }
      return MessageTypes.None
    }

    const handleActualValueChange = (Index, key, id, valueIndex, newValue) => {
      const updatedProcessObj = [...detailObj];
      updatedProcessObj[Index][key][id].Actual_Value[valueIndex] = newValue;
      setdetailObj(updatedProcessObj);
      setIsEdited(true);
    };

    const handleOtherChange = (Index, key, id, valueIndex, newValue) => {
      const updatedProcessObj = [...detailObj];
      updatedProcessObj[Index][key][id].Other[valueIndex] = newValue;
      setdetailObj(updatedProcessObj);
      setIsEdited(true)
    };

    const handleRangeQualifiedChange = (Index, key, id, valueIndex, newValue) => {
      const updatedProcessObj = [...detailObj];
      updatedProcessObj[Index][key][id].Range_Qualified[valueIndex] = newValue;
      setdetailObj(updatedProcessObj);
      setIsEdited(true)
    };

    const handleRangeQualifiedChange2 = (Index, key, id, valueIndex, valueIndex2, checkedbox, newValue) => {
      const updatedProcessObj = [...detailObj];
      updatedProcessObj[Index][key][id].Range_Qualified[0].Range_Qualified1[0] = newValue;
      console.log("newvalue", updatedProcessObj)
      setdetailObj(updatedProcessObj);
      setIsEdited(true)
    };

    const handleRangeQualifiedChangeCheckBox = (Index, key, id, valueIndex, Value) => {
      const updatedProcessObj = [...detailObj];

      let booleanIndex =
        updatedProcessObj[Index][key][id].Range_Qualified[valueIndex][1];

      let newValue = checkboxComponent(valueIndex, Value, booleanIndex);
      if (newValue) {
        newValue = newValue.Value;
        updatedProcessObj[Index][key][id].Range_Qualified[valueIndex][0] =
          newValue;

        if (newValue != "") {
          updatedProcessObj[Index][key][id].Range_Qualified[valueIndex][1] =
            "true";
          updatedProcessObj[Index][key][id].Range_Qualified[valueIndex][2] =
            "Checked";
        } else if (newValue === "") {
          updatedProcessObj[Index][key][id].Range_Qualified[valueIndex][1] =
            "false";
          updatedProcessObj[Index][key][id].Range_Qualified[valueIndex][2] =
            "Unchecked";
        }

        setdetailObj(updatedProcessObj);
        setIsEdited(true)
      }
    };

    const handleRangeQualifiedChangeCheckBox2 = (Index, key, id, checkedbox) => {
      const updatedProcessObj = [...detailObj];
      let checked = "true", checkedval = "Checked", Value = "9.999.00"
      console.log("checkbox", checkedbox)
      if (!checkedbox) {
        Value = "";
        checked = "false";
        checkedval = "Unchecked";
      }

      updatedProcessObj[Index][key][id].Range_Qualified[0].Range_Qualified1[0] = Value;
      updatedProcessObj[Index][key][id].Range_Qualified[2].Range_Qualified2[0][1] = checked;
      updatedProcessObj[Index][key][id].Range_Qualified[2].Range_Qualified2[0][2] = checkedval;
      console.log("checkvalue", updatedProcessObj[Index][key][id])
      setdetailObj(updatedProcessObj);
      setIsEdited(true)
    };


    const validateTemp = async () => {
      let isError = false;
      let temperror = emptyErrorWPQDetail(error, setError, isError);
      return { isError, temperror };
    };

    const handleAdd = async (savetype) => {
      let result = false;
      if (
        headerObj?.WPSH_Status === Status.StatusApproved ||
        headerObj?.WPSH_Status === Status.StatusRejected
      ) {
        headerObj.WPSH_Status = Status.StatusPending;
      }
      let detaildata = detailObj?.filter((item) => item.WPQ_Process !== "");

      for (const item of detaildata) {
        item.WPSH_Status = headerObj.WPSH_Status;
        console.log("WPQGetDetailProcess - Syncing WPSH_Status:", item.WPSH_Status, "for process:", item.WPQ_Process);

        await AddNewDetail(item).then(async (r) => {
          result = true;
          if (
            action === Action.ActionEdit &&
            savetype !== Status.StatusTempSaved
          ) {

            result = true;
          }
        });
      }
      return result;
    };



    // Safely parse "DD-MM-YYYY" format
    const rawDate = wpq_process?.wld_createdon;
    let isToggleEditable = false;
    console.log("wpq_process:", wpq_process)
    console.log("rawDate:", rawDate)
    if (rawDate) {
      const [day, month, year] = rawDate.split("-");
      const createdDate = new Date(`${year}-${month}-${day}`);
      createdDate.setHours(0, 0, 0, 0); // Remove time

      const expiryDate = new Date(createdDate);
      expiryDate.setDate(expiryDate.getDate() + 178);
      expiryDate.setHours(0, 0, 0, 0); // Remove time

      const today = new Date();
      today.setHours(0, 0, 0, 0); // Remove time
      console.log("expiryDate:", expiryDate, today)
      isToggleEditable = today <= expiryDate;
    }
    return (
      <Row className="font">
        {loading && (
          <div className="loader-overlay">
            <DotLoader size={80} className="pageloader" />
          </div>
        )}
        <Row className="mb-4" style={{ padding: "0px 58px" }}>
          <div className="statusbg">
            <span
              className="statusborder float-start"
              style={{ display: "flex", alignItems: "center", gap: "2px" }} // reduced gap
            >
              <span style={{ marginRight: "-10px" }}>Status</span>
              <Form.Switch
                disabled={!isToggleEditable}
                name="wld_process_status"
                checked={wpq_process?.wld_process_status === "Active"}
                className={
                  wpq_process?.wld_process_status === "Active"
                    ? "semiBoldToggleButton activeToggleLabel"
                    : "semiBoldToggleButton inactiveToggleLabel"
                }
                onChange={(e) => {
                  if (!isToggleEditable) return;

                  const newStatus = e.target.checked ? "Active" : "Inactive";
                  const updatedProcess = { ...wpq_process, wld_process_status: newStatus };

                  setdetailObj((prev) => {
                    const updated = [...prev];
                    updated[Index] = updatedProcess;
                    return updated;
                  });

                  setIsEdited(true);
                }}
              />
              <span
                style={{
                  marginLeft: "4px",
                  color:
                    wpq_process?.wld_process_status === "Inactive"
                      ? "var(--godrej-orange)"
                      : "var(--godrej-green-alt)",
                }}
              >
                {wpq_process?.wld_process_status}
              </span>
            </span>
            <span className="statusborder float-end">
              Last Weld Date &nbsp;&nbsp;&nbsp;
              <span className="WPQ-Green-text">{wpq_process?.wld_createdon}</span>
            </span>
          </div>
        </Row>
        <Row className="mb-4" style={{ padding: "20px 48px" }}>
          <Col>
            <Table
              bordered
              responsive="sm"
              className="text-center same-col-widths align-middle"
            >
              <thead>
                <tr className="border thead-color ">
                  <th
                    className="thickness_title tablethwidth"
                    style={{ width: "20%" }}
                  ></th>
                  <th
                    id="av"
                    className="thickness_title tablethwidth"
                    style={{ width: "10%" }}
                  >
                    Actual Value
                  </th>
                  <th
                    id="rq"
                    className="thickness_title tablethwidth "
                    style={{ width: "25%" }}
                  >
                    Range Qualified
                  </th>
                  <th className="thickness_title tablethwidth"></th>
                </tr>
              </thead>
              <thead>
                <tr className="align-middle">
                  <th className="text-start thead-color">Process</th>
                  <td>{wpq_process?.WPQ_Process}</td>
                  <td>{wpq_process?.WPQ_Process}</td>
                  <td>{wpq_process?.WPQ_Process_Category}</td>
                </tr>
                <tr className="align-middle">
                  <th className="text-start thead-color">Type</th>
                  <td>{wpq_process?.WPQ_Type}</td>
                  <td>{wpq_process?.WPQ_Type}</td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                <WPQProcessSelect
                  wpq_process={wpq_process}
                  Index={Index}
                  name="WPQ_Detail_Backing"
                  disabled={isDisabled}
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader="Backing"
                  array={Backing}
                  status={error.WPQ_Detail_Backing[0].Actual_Value[0].status}
                  message={error.WPQ_Detail_Backing[0].Actual_Value[0].message}
                  status1={
                    error.WPQ_Detail_Backing[1].Range_Qualified[0].status
                  }
                  message1={
                    error.WPQ_Detail_Backing[1].Range_Qualified[0].message
                  }
                />
                <WPQProcessSelectData
                  wpq_process={wpq_process}
                  Index={Index}
                  disabled={isDisabled}
                  customstyles={customstyles}
                  customstyles2={customstyles2}
                  name="WPQ_FM_Specification"
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader="Filler Metal Specification (SFA NO.)"
                  SfaActive={SfaActive}
                  valueField="wld_code"
                  status={error.WPQ_FM_Specification[0].Actual_Value[0].status}
                  message={
                    error.WPQ_FM_Specification[0].Actual_Value[0].message
                  }
                  status1={
                    error.WPQ_FM_Specification[1].Range_Qualified[0].status
                  }
                  message1={
                    error.WPQ_FM_Specification[1].Range_Qualified[0].message
                  }
                />
                <WPQProcessInput1
                  wpq_process={wpq_process}
                  Index={Index}
                  name="WPQ_FM_Classification"
                  readOnly={isReadonly}
                  maxlength={10}
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader="Filler Metal Classification"
                  status={error.WPQ_FM_Classification[0].Actual_Value[0].status}
                  message={
                    error.WPQ_FM_Classification[0].Actual_Value[0].message
                  }
                  status1={
                    error.WPQ_FM_Classification[1].Range_Qualified[0].status
                  }
                  message1={
                    error.WPQ_FM_Classification[1].Range_Qualified[0].message
                  }
                  error={error}
                  setError={setError}
                  allowlistfunction={isAllowDashedSpecialCharacters}
                />
                <WPQProcessSelect
                  wpq_process={wpq_process}
                  Index={Index}
                  name="WPQ_FM_filler_Wire"
                  disabled={isDisabled}
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader="Filler Wire With/Without"
                  array={Filler_Wire_With_Without}
                  status={error.WPQ_FM_filler_Wire[0].Actual_Value[0].status}
                  message={error.WPQ_FM_filler_Wire[0].Actual_Value[0].message}
                  status1={
                    error.WPQ_FM_filler_Wire[1].Range_Qualified[0].status
                  }
                  message1={
                    error.WPQ_FM_filler_Wire[1].Range_Qualified[0].message
                  }
                />
                <WPQProcessInput1Row3
                  customstyles={customstyles}
                  Index={Index}
                  wpq_process={wpq_process}
                  name="WPQ_FM_F_No"
                  disabled={isDisabled}
                  readOnly={isReadonly}
                  maxlength={11}
                  handleOtherChange={handleOtherChange}
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader={
                    <span className="greenfont" style={{ fontWeight: "700" }}>
                      Filler Metal F-Number (Category - F No.)
                    </span>
                  }
                  SfaActive={FnoActive}
                  valueField="wld_category"
                  combinedLabel={"wld_code"}
                  combinedOptions={true}
                  status={error.WPQ_FM_F_No[0].Actual_Value[0].status}
                  message={error.WPQ_FM_F_No[0].Actual_Value[0].message}
                  status1={error.WPQ_FM_F_No[1].Range_Qualified[0].status}
                  message1={error.WPQ_FM_F_No[1].Range_Qualified[0].message}
                  error={error}
                  setError={setError}
                />
                <WPQProcessSelect
                  wpq_process={wpq_process}
                  Index={Index}
                  disabled={isDisabled}
                  name="WPQ_FM_Arc_transfermode"
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader={
                    <span className="greenfont" style={{ fontWeight: "700" }}>
                      Arc Transfer Mode (FCAW/GMAW)
                    </span>
                  }
                  array={Arc_Transfer}
                  status={
                    error.WPQ_FM_Arc_transfermode[0].Actual_Value[0].status
                  }
                  message={
                    error.WPQ_FM_Arc_transfermode[0].Actual_Value[0].message
                  }
                  status1={
                    error.WPQ_FM_Arc_transfermode[1].Range_Qualified[0].status
                  }
                  message1={
                    error.WPQ_FM_Arc_transfermode[1].Range_Qualified[0].message
                  }
                />
                <WPQProcessSelect
                  wpq_process={wpq_process}
                  Index={Index}
                  disabled={isDisabled}
                  name="WPQ_FM_Consumable_Insert"
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader={
                    <span className="greenfont" style={{ fontWeight: "700" }}>
                      Consumable Insert
                    </span>
                  }
                  array={Consumable_Insert}
                  status={
                    error.WPQ_FM_Consumable_Insert[0].Actual_Value[0].status
                  }
                  message={
                    error.WPQ_FM_Consumable_Insert[0].Actual_Value[0].message
                  }
                  status1={
                    error.WPQ_FM_Consumable_Insert[1].Range_Qualified[0].status
                  }
                  message1={
                    error.WPQ_FM_Consumable_Insert[1].Range_Qualified[0].message
                  }
                />

                <WPQProcessSelect
                  wpq_process={wpq_process}
                  Index={Index}
                  name="WPQ_FM_Product_Form"
                  disabled={isDisabled}
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader={
                    <span className="greenfont" style={{ fontWeight: "700" }}>
                      Filler Metal Product Form (GTAW)
                    </span>
                  }
                  array={FM_Product_Form_GTAW}
                  status={error.WPQ_FM_Product_Form[0].Actual_Value[0].status}
                  message={error.WPQ_FM_Product_Form[0].Actual_Value[0].message}
                  status1={
                    error.WPQ_FM_Product_Form[1].Range_Qualified[0].status
                  }
                  message1={
                    error.WPQ_FM_Product_Form[1].Range_Qualified[0].message
                  }
                />
                <WPQProcessInput1
                  wpq_process={wpq_process}
                  Index={Index}
                  readOnly={isReadonly}
                  maxlength={8}
                  name="WPQ_FM_No_of_LayerDeposit"
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader="No Of Layer Deposited"
                  status={
                    error.WPQ_FM_No_of_LayerDeposit[0].Actual_Value[0].status
                  }
                  message={
                    error.WPQ_FM_No_of_LayerDeposit[0].Actual_Value[0].message
                  }
                  status1={
                    error.WPQ_FM_No_of_LayerDeposit[1].Range_Qualified[0].status
                  }
                  message1={
                    error.WPQ_FM_No_of_LayerDeposit[1].Range_Qualified[0]
                      .message
                  }

                  error={error}
                  setError={setError}
                />
                <WPQProcessInputAndCheckbox
                  readOnly={isReadonly}
                  Index={Index}
                  wpq_process={wpq_process}
                  name="WPQ_FM_Weld_Deposit_Thickness"
                  error={error}
                  maxlength={10}
                  setError={setError}
                  disabled={isDisabled}
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  handleRangeQualifiedChange2={handleRangeQualifiedChange2}
                  handleRangeQualifiedChangeCheckBox2={
                    handleRangeQualifiedChangeCheckBox2
                  }
                  ColumnHeader="Weld Deposit Thickness (mm)"
                  status={
                    error.WPQ_FM_Weld_Deposit_Thickness[0]?.Actual_Value[0].status
                  }
                  message={
                    error.WPQ_FM_Weld_Deposit_Thickness[0]?.Actual_Value[0].message
                  }

                  onInput={(e) => {
                    let error = isAlphanumericAllSpecialCharacters(e.target.value);
                    setError((prevState) => ({
                      ...prevState,
                      WPQ_FM_Weld_Deposit_Thickness: [
                        { Actual_Value: [error] },
                        { Range_Qualified: [{ Range_Qualified1: [""] }] },
                      ],
                    }));
                  }}
                  onInput1={(e) => {
                    let error = numberMax10Digits(e.target.value);
                    setError((prevState) => ({
                      ...prevState,
                      WPQ_FM_Weld_Deposit_Thickness: [
                        { Actual_Value: [error] },
                        { Range_Qualified: [error] },
                      ],
                    }));
                  }}
                />

                <WPQProcessInput1
                  readOnly={isReadonly}
                  Index={Index}
                  wpq_process={wpq_process}
                  maxlength={7}
                  name="WPQ_FM_Thickness_Limit"
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader="Thickness Limit (S.Cir.Arc)"
                  status={
                    error.WPQ_FM_Thickness_Limit[0].Actual_Value[0].status
                  }
                  message={
                    error.WPQ_FM_Thickness_Limit[0].Actual_Value[0].message
                  }
                  status1={
                    error.WPQ_FM_Thickness_Limit[1].Range_Qualified[0].status
                  }
                  message1={
                    error.WPQ_FM_Thickness_Limit[1].Range_Qualified[0].message
                  }

                  error={error}
                  setError={setError}
                />
                <WPQProcessInput1
                  readOnly={isReadonly}
                  Index={Index}
                  wpq_process={wpq_process}
                  maxlength={10}
                  name="WPQ_FM_Welding_Position"
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader="Welding Position (Actual Position Tested)"
                  status={
                    error.WPQ_FM_Welding_Position[0].Actual_Value[0].status
                  }
                  message={
                    error.WPQ_FM_Welding_Position[0].Actual_Value[0].message
                  }
                  status1={
                    error.WPQ_FM_Welding_Position[1].Range_Qualified[0].status
                  }
                  message1={
                    error.WPQ_FM_Welding_Position[1].Range_Qualified[0].message
                  }
                  error={error}
                  setError={setError}
                />
                {isgroove ? (
                  <>
                    <WPQProcessCheckBox
                      wpq_process={wpq_process}
                      Index={Index}
                      name="WPQ_Groove_610"
                      disabled={isDisabled}
                      handleActualValueChange={handleActualValueChange}
                      handleRangeQualifiedChangeCheckBox={
                        handleRangeQualifiedChangeCheckBox
                      }
                      ColumnHeader={
                        <span
                          className="greenfont"
                          style={{ fontWeight: "700" }}
                        >
                          Groove-Plate & Pipe {">"} 610mm
                        </span>
                      }
                    />
                    <WPQProcessCheckBox
                      wpq_process={wpq_process}
                      Index={Index}
                      name="WPQ_Groove_73to610"
                      disabled={isDisabled}
                      handleActualValueChange={handleActualValueChange}
                      handleRangeQualifiedChangeCheckBox={
                        handleRangeQualifiedChangeCheckBox
                      }
                      ColumnHeader={
                        <span
                          className="greenfont"
                          style={{ fontWeight: "700" }}
                        >
                          Groove-Pipe 73 to 610mm
                        </span>
                      }
                    />

                    <WPQProcessCheckBox
                      wpq_process={wpq_process}
                      Index={Index}
                      name="WPQ_Groove_73"
                      disabled={isDisabled}
                      handleActualValueChange={handleActualValueChange}
                      handleRangeQualifiedChangeCheckBox={
                        handleRangeQualifiedChangeCheckBox
                      }
                      ColumnHeader={
                        <span
                          className="greenfont"
                          style={{ fontWeight: "700" }}
                        >
                          Groove-Pipe {"<"} 73mm
                        </span>
                      }
                    />

                    <WPQProcessCheckBox
                      wpq_process={wpq_process}
                      Index={Index}
                      name="WPQ_Fillet_610"
                      disabled={isDisabled}
                      handleActualValueChange={handleActualValueChange}
                      handleRangeQualifiedChangeCheckBox={
                        handleRangeQualifiedChangeCheckBox
                      }
                      ColumnHeader={
                        <span style={{ fontWeight: "700" }}>
                          Fillet-Plate & pipe{">"} 610mm
                        </span>
                      }
                    />

                    <WPQProcessCheckBox
                      wpq_process={wpq_process}
                      Index={Index}
                      name="WPQ_Fillet_73to610"
                      disabled={isDisabled}
                      handleActualValueChange={handleActualValueChange}
                      handleRangeQualifiedChangeCheckBox={
                        handleRangeQualifiedChangeCheckBox
                      }
                      ColumnHeader="Fillet-Pipe 73mm to 610mm"
                    />

                    <WPQProcessCheckBox
                      wpq_process={wpq_process}
                      Index={Index}
                      name="WPQ_Fillet_73"
                      disabled={isDisabled}
                      handleActualValueChange={handleActualValueChange}
                      handleRangeQualifiedChangeCheckBox={
                        handleRangeQualifiedChangeCheckBox
                      }
                      ColumnHeader="Fillet-Pipe < 73mm"
                    />
                  </>
                ) : (
                  <>
                    <WPQProcessCheckBox
                      wpq_process={wpq_process}
                      Index={Index}
                      name="WPQ_Overlay_610"
                      disabled={isDisabled}
                      handleActualValueChange={handleActualValueChange}
                      handleRangeQualifiedChangeCheckBox={
                        handleRangeQualifiedChangeCheckBox
                      }
                      ColumnHeader={
                        <span
                          className="greenfont"
                          style={{ fontWeight: "700" }}
                        >
                          Overlay-Plate & Pipe {">"} 610mm
                        </span>
                      }
                    />

                    <WPQProcessCheckBox
                      wpq_process={wpq_process}
                      Index={Index}
                      name="WPQ_Overlay_73to610"
                      disabled={isDisabled}
                      handleActualValueChange={handleActualValueChange}
                      handleRangeQualifiedChangeCheckBox={
                        handleRangeQualifiedChangeCheckBox
                      }
                      ColumnHeader={
                        <span
                          className="greenfont"
                          style={{ fontWeight: "700" }}
                        >
                          Overlay-Pipe 73 to 610mm
                        </span>
                      }
                    />

                    <WPQProcessCheckBox
                      wpq_process={wpq_process}
                      Index={Index}
                      name="WPQ_Overlay_73"
                      disabled={isDisabled}
                      handleActualValueChange={handleActualValueChange}
                      handleRangeQualifiedChangeCheckBox={
                        handleRangeQualifiedChangeCheckBox
                      }
                      ColumnHeader={
                        <span
                          className="greenfont"
                          style={{ fontWeight: "700" }}
                        >
                          Overlay-Pipe {"<"} 73mm
                        </span>
                      }
                    />
                  </>
                )}

                <WPQProcessSelect
                  disabled={isDisabled}
                  Index={Index}
                  wpq_process={wpq_process}
                  name="WPQ_FM_Progression"
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader="Progression"
                  array={Weld_Progression}
                  status={error.WPQ_FM_Progression[0].Actual_Value[0].status}
                  message={error.WPQ_FM_Progression[0].Actual_Value[0].message}
                  status1={
                    error.WPQ_FM_Progression[1].Range_Qualified[0].status
                  }
                  message1={
                    error.WPQ_FM_Progression[1].Range_Qualified[0].message
                  }
                />

                <WPQProcessSelect
                  disabled={isDisabled}
                  Index={Index}
                  wpq_process={wpq_process}
                  name="WPQ_FM_Current_Polarity"
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader={
                    <span className="greenfont" style={{ fontWeight: "700" }}>
                      Current / Polarity
                    </span>
                  }
                  array={Current_Polarity}
                  status={
                    error.WPQ_FM_Current_Polarity[0].Actual_Value[0].status
                  }
                  message={
                    error.WPQ_FM_Current_Polarity[0].Actual_Value[0].message
                  }
                  status1={
                    error.WPQ_FM_Current_Polarity[1].Range_Qualified[0].status
                  }
                  message1={
                    error.WPQ_FM_Current_Polarity[1].Range_Qualified[0].message
                  }
                />

                <WPQProcessSelect
                  disabled={isDisabled}
                  Index={Index}
                  wpq_process={wpq_process}
                  name="WPQ_FM_Backing_Gas"
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader="Backing Gas"
                  array={Backing_Gas}
                  status={error.WPQ_FM_Backing_Gas[0].Actual_Value[0].status}
                  message={error.WPQ_FM_Backing_Gas[0].Actual_Value[0].message}
                  status1={
                    error.WPQ_FM_Backing_Gas[1].Range_Qualified[0].status
                  }
                  message1={
                    error.WPQ_FM_Backing_Gas[1].Range_Qualified[0].message
                  }
                />

                <WPQProcessSelect
                  disabled={isDisabled}
                  Index={Index}
                  wpq_process={wpq_process}
                  name="WPQ_FM_Direct_VisualControl"
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader="Direct/Remote visual control (Machine)"
                  array={Direct_Visual}
                  status={
                    error.WPQ_FM_Direct_VisualControl[0].Actual_Value[0].status
                  }
                  message={
                    error.WPQ_FM_Direct_VisualControl[0].Actual_Value[0].message
                  }
                  status1={
                    error.WPQ_FM_Direct_VisualControl[1].Range_Qualified[0]
                      .status
                  }
                  message1={
                    error.WPQ_FM_Direct_VisualControl[1].Range_Qualified[0]
                      .message
                  }
                />

                <WPQProcessSelect
                  disabled={isDisabled}
                  Index={Index}
                  wpq_process={wpq_process}
                  name="WPQ_FM_Automatic_jointTracking"
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader="Automatic joint tracking (Machine)"
                  array={WPQ_FM_Automatic_jointTracking}
                  status={
                    error.WPQ_FM_Automatic_jointTracking[0].Actual_Value[0]
                      .status
                  }
                  message={
                    error.WPQ_FM_Automatic_jointTracking[0].Actual_Value[0]
                      .message
                  }
                  status1={
                    error.WPQ_FM_Automatic_jointTracking[1].Range_Qualified[0]
                      .status
                  }
                  message1={
                    error.WPQ_FM_Automatic_jointTracking[1].Range_Qualified[0]
                      .message
                  }
                />
                <WPQProcessSelect
                  disabled={isDisabled}
                  Index={Index}
                  wpq_process={wpq_process}
                  name="WPQ_FM_Single_Pass_PerSide"
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader="Single Pass/Multi pass per side"
                  array={Single_Pass}
                  status={
                    error.WPQ_FM_Single_Pass_PerSide[0].Actual_Value[0].status
                  }
                  message={
                    error.WPQ_FM_Single_Pass_PerSide[0].Actual_Value[0].message
                  }
                  status1={
                    error.WPQ_FM_Single_Pass_PerSide[1].Range_Qualified[0]
                      .status
                  }
                  message1={
                    error.WPQ_FM_Single_Pass_PerSide[1].Range_Qualified[0]
                      .message
                  }
                />
                <WPQProcessInput1
                  readOnly={isReadonly}
                  Index={Index}
                  wpq_process={wpq_process}
                  maxlength={7}
                  name="WPQ_FM_Automatic_AVC_System"
                  handleActualValueChange={handleActualValueChange}
                  handleRangeQualifiedChange={handleRangeQualifiedChange}
                  ColumnHeader="Automatic AVC System (GTAW)"
                  status={
                    error.WPQ_FM_Automatic_AVC_System[0].Actual_Value[0].status
                  }
                  message={
                    error.WPQ_FM_Automatic_AVC_System[0].Actual_Value[0].message
                  }
                  status1={
                    error.WPQ_FM_Automatic_AVC_System[1].Range_Qualified[0]
                      .status
                  }
                  message1={
                    error.WPQ_FM_Automatic_AVC_System[1].Range_Qualified[0]
                      .message
                  }
                  error={error}
                  setError={setError}
                />
              </tbody>
            </Table>
          </Col>
        </Row>
      </Row>
    );
  }
);

export default WPQGetDetailProcess;